import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

import actions from './actions'
import getters from './getters.coffee'
import mutations from './mutations.coffee'
import mutationsV2 from './mutationsV2'

import { nodeApi } from '../config'

Vue.use(Vuex)

console.log('nodeApi is ', nodeApi)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex_freq_list_14', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: (state) => {
    return ({
      user: state.user,
      uuid: state.uuid,
      display: state.display,
      videoSeen: state.videoSeen,
      words: state.words
    })
  }
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export const store = new Vuex.Store({
  state: {
    isConnected: false,
    apiUrl: nodeApi,
    uuid: null,
    currentWord: {},
    layout: 'front-layout',
    layoutBackground: '',
    words: [],
    wordOpts: [],
    sentences: {},
    currentSentence: {},
    display: {
      filters: true,
    },
    voices: {
      'en-US': "Samantha",
      'en-GB': "Daniel",
      'hu-HU': "Mariska",
      'fr-FR': 'Thomas',
      'es-ES': 'Jorge',
      "ru-RU": "Milena",
    },
    user: {},
    votes: {},
    filters: {
      lemma: {},
      pos: {},
      phonemes: {},
      stressPatterns: {},
      syllables: {},
      videos: {},
      options: {
        searchStartsWith: false,
        searchEndsWith: false,
        searchIsRegex: false,
        withVideoOnly: false
      }
    },
    sentencePlayerRev: 1,
    videoSeen: false
  },
  plugins: [vuexLocalStorage.plugin],
  actions,
  getters,
  mutations: {
    ...mutations,
    ...mutationsV2
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js